var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDownloadSvg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 22,
    viewBox: "0 0 24 22",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#200e32",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "m11.8978 15.1852v-14.1852"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.3335 11.7361-3.4353 3.4494-3.43522-3.4494"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.3553 6.57568h1.0991c2.3974 0 4.34 1.94264 4.34 4.34122v5.7537c0 2.3915-1.9379 4.3294-4.3294 4.3294h-13.12369c-2.39738 0-4.3412-1.9438-4.3412-4.3412v-5.7549c0-2.39029 1.93911-4.32822 4.32942-4.32822h1.10974",
    opacity: 0.4
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadSvg);
export default __webpack_public_path__ + "static/media/DownloadSVG.c1cab32d.svg";
export { ForwardRef as ReactComponent };